"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageValidators = void 0;
exports.languageValidators = {
    hy: {
        regex: /^[աբգդեզէըթժիլխծկհձղճմյնշոչպջռսվտրցւփքօֆևԱԲԳԴԵԶԷԸԹԺԻԼԽԾԿՀՁՂՃՄՅՆՇՈՉՊՋՌՍՎՏՐՑՒՓՔՕՖ0-9_. ։:,;!@#$%^&*+={}()/\-․֊«»<>―՞\?՝`~՜՛'"\s]*$/,
    },
    en: {
        regex: /^[a-zA-Z0-9_. ։:,;!@#$%^&*+={}()/\-․֊«»<>―՞\?՝`~՜՛'"\s]*$/,
    },
    ru: {
        regex: /^[аАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯ0-9_. ։:,;!@#$%^&*+={}()/\-․֊«»<>―՞\?՝`~՜՛'"\s]*$/,
    },
};
